import { memo } from 'react';
import ReactMarkdown from 'react-markdown';
import RemarkMath from 'remark-math';
import RemarkBreaks from 'remark-breaks';
import RemarkGfm from 'remark-gfm';
import { rehypeKatex } from './helper';
import RehypeHighlight from 'rehype-highlight';
import { copyToClipboard, previewPicture } from '@/sub-luca-plugin/utils';
import classNames from 'classnames';
import 'katex/dist/katex.min.css';
import './index.scss';

interface IProps {
    content: any;
    status?: string;
    cancelPreview?: boolean;
    imgType?: 'normal' | 'welcome';
    className?: string;
    disabledPreLine?: boolean;
}

const Markdown = (props: IProps) => {
    const { content, imgType = 'normal', className } = props;
    if (!content) return null;
    // console.log('content', content);
    const newContent = content.replace(/\\\[\n*\s*|\n*\s*\\\]|\\\(\n*\s*|\n*\s*\\\)/g, '$').replace(/\<br\>/g, ' ');
    // console.log(newContent);
    return (
        <ReactMarkdown
            className={classNames('markdown-body', className)}
            remarkPlugins={[[RemarkMath, { singleDollarTextMath: true }], RemarkGfm, RemarkBreaks]}
            rehypePlugins={[
                [rehypeKatex, { minRuleThickness: 0.11 }],
                [
                    RehypeHighlight,
                    {
                        detect: false,
                        ignoreMissing: true,
                    },
                ],
            ]}
            components={{
                pre: props => {
                    let preELe: HTMLPreElement | null;
                    return (
                        <pre
                            ref={el => {
                                preELe = el;
                            }}
                        >
                            <span className="copy-code-button" onClick={() => copyToClipboard(preELe?.innerText || '')}></span>
                            {props.children}
                        </pre>
                    );
                },
                img: imgProps => {
                    return imgType === 'normal' ? (
                        <img src={imgProps.src} onClick={() => previewPicture(imgProps.src!)} />
                    ) : (
                        <>
                            <br />
                            <span className="welcome-image-container">
                                <img src={imgProps.src} onClick={() => previewPicture(imgProps.src!)} />
                            </span>
                        </>
                    );
                },
                a: ({ href, ...props }) => {
                    if (href === 'loading') {
                        return <span className="verbatim-loading" />;
                    }
                    if (href && /\/\/#[\d\w]{6}/.test(href)) {
                        const color = `#${href.split('#')[1]}`;
                        return <span style={{ backgroundColor: color }}>{props.children}</span>;
                    }
                    return (
                        <a
                            href="#"
                            rel="noreferrer"
                            onClick={e => {
                                e.preventDefault();
                                window.open(href);
                            }}
                        >
                            {props.children}
                        </a>
                    );
                },
                table: props => {
                    return (
                        <div className="table-container">
                            <div className="table-scroll-container">
                                <table>{props.children}</table>
                            </div>
                        </div>
                    );
                },
            }}
        >
            {newContent}
        </ReactMarkdown>
    );
};

export default memo(Markdown);
